import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { initRemoteLog } from "./utils/remoteLog";

// Start the client-log transport + global error/unhandledrejection handlers
// (ADR-009) before the app mounts so even bootstrap-time crashes are captured.
initRemoteLog();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
